import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import FilterAssetsModalContent from './FilterAssetsModalContent';
export const FilterAssetsModal = {
    show: (selectedFiler, onSelectFilter) => {
        Modal.show(<FilterAssetsModalContent selectedFiler={selectedFiler} onSelectFilter={onSelectFilter} hideModal={Modal.hide}/>, {
            containerStyle: styles.modal,
            title: 'Sort by',
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
